import { useEffect, useState, useCallback } from "react";
import newRequest from "../context/newRequest";

const defaultVendors = [
  { id: "INDONUSA", description: "INDONUSA" },
  { id: "FMI", description: "FMI" },
  { id: "IFORTE", description: "IFORTE" },
  { id: "FIBERNET", description: "FIBERNET" },
  { id: "TIS", description: "TIS" },
  { id: "HSP", description: "HSP" },
  { id: "ALCEN / HSP", description: "ALCEN / HSP" },
  { id: "HSP / JUJUNG", description: "HSP / JUJUNG" },
  { id: "TELKOM", description: "TELKOM" },
  { id: "SIAPNET", description: "SIAPNET" },
  { id: "MORATELINDO", description: "MORATELINDO" },
  { id: "FMI KSO", description: "FMI KSO" },
  { id: "GREENET TO MAINTENANCE", description: "GREENET TO MAINTENANCE" },
  { id: "GREENET", description: "GREENET" },
];

export const useVendors = () => {
  const [vendors, setVendors] = useState(defaultVendors);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchVendors = useCallback(async () => {
    setLoading(true);
    try {
      const res = await newRequest.get("/vendors");
      const list = res.data && res.data.data;
      if (Array.isArray(list) && list.length > 0) {
        setVendors(list);
      }
    } catch (err) {
      console.warn("Could not fetch vendors from API, using defaults:", err);
      setError(err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchVendors();
  }, [fetchVendors]);

  return { vendors, loading, error, refreshVendors: fetchVendors };
};

export default useVendors;
